<template>
    <div :class="['c-field', widthClass, {
        'c-field--horizontal': horizontal
    }]"
    >
        <!-- Label  -->
        <BaseStack
            v-if="hasLabel"
            class="c-field__label"
            spacing="0"
        >
            <BaseInline element="label">
                <!-- @slot Adds a label tag for the input -->
                <slot name="label">
                    <label :class="[optional ? '' : 'font-semibold', {
                        ' text-gray-400': disabled
                    }]"
                    >
                        {{label}}
                    </label>
                </slot>
                <!-- @slot Adds a help icon after label -->
                <slot name="help">
                    <BaseFlyout v-if="label && help"
                        :bodyHTML="help"
                        inlinePosition="after"
                        :isHelp="true"
                    />
                </slot>
            </BaseInline>
            <!-- @slot Adds a description below the label -->
            <div v-if="hasDescription" class="c-field__description">
                <slot name="description">
                    <label>
                        {{description}}
                    </label>
                </slot>
            </div>
        </BaseStack>

        <!-- Content -->
        <div :class="['c-field__content', {
            'inline-block': inputInline
        }]"
        >
            <!-- @slot The default slot for the form control -->
            <slot></slot>
        </div>
    </div>
</template>

<script>

import './c-field.css';
export default {
    name: 'BaseField',
    props: {
        /**
        * The form control label.
        */
        label: [String, Number],
        /**
        * @ignore This prop is not used.
        */
        labelFlyout: String,
        /**
        * Help text to be displayed in a flyout proceeding the label
        */
        help: String,
        /**
        * The form control description
        */
        description: [String, Number],
        /**
        * @ignore This prop is not used.
        */
        message: [String, Array],
        /**
        * Adds a class of ''c-field--horizontal' to the element.
        */
        horizontal: Boolean,
        /**
        * If true, removes the class of 'font-semibold' to the label tag.
        */
        optional: Boolean,
        /**
        * Adds a width class to the element `c-field--${this.width}`
        */
        width: {
            type: String,
            default: '',
            validator(value){
                return [
                    'short',
                    'medium',
                    'large',
                    'full',
                    ''
                ].includes(value);
            }
        },
        inputInline: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasDescription(){
            return !!this.$slots.description || this.description;
        },
        hasLabel(){
            return !!this.$slots.label || this.label;
        },
        widthClass(){
            if (!this.width) {
                return '';
            }

            return `c-field--${this.width}`;
        }
    }
};
</script>